<!--移动端埋点检查下的app传入参数-->
<template>
    <div class="mobile-app-transparent">
        <el-table
            :data="detailData"
            border
            style="width: 100%">
            <el-table-column
                type="index"
                :index="indexMethod">
            </el-table-column>
            <el-table-column
                prop="fieldName"
                label="字段名称">
            </el-table-column>
            <el-table-column
                prop="fieldValue"
                label="字段值">
            </el-table-column>
            <el-table-column
                prop="fieldDes"
                label="字段说明">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "mobile-apptransparent",
        props: {
            detailData: Array
        },
        data() {
            return {}
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            }
        }
    }
</script>

<style lang="scss">
    .component-page-group {
        .head-btns, .el-button--primary {
            border: none;
            color: #fff !important;
        }
    }
</style>
